{
  "VALIDATION_FAILED": "The submitted data is not valid",
  "USERNAME_TAKEN": "This username is already in use",
  "NO_PLATFORM_ACCESS": "You do not have access to this platform",
  "UA_UNAVAILABLE": "Unified Access could not be reached. Try again shortly.",
  "UNAUTHENTICATED": "You need to sign in",
  "INVALID_CREDENTIALS": "Invalid email or password",
  "TOKEN_EXPIRED": "Your session expired",
  "TOKEN_REVOKED": "This session was revoked",
  "FORBIDDEN": "You do not have permission for this action",
  "NOT_FOUND": "The requested item was not found",
  "routeNotFound": "This page does not exist.",
  "CONFLICT": "Conflicting data. Reload the current data.",
  "UNIQUE_VIOLATION": "This value is already in use",
  "FOREIGN_KEY_VIOLATION": "This item is referenced elsewhere and cannot be deleted",
  "RATE_LIMITED": "Too many attempts. Try again shortly.",
  "IDEMPOTENCY_KEY_REUSED": "This request number was already used for another operation",
  "REQUEST_IN_PROGRESS": "This request is still being processed",
  "PAYLOAD_TOO_LARGE": "The submitted data exceeds the maximum size",
  "UNPROCESSABLE": "The request could not be processed. Check the submitted data.",
  "INTERNAL_ERROR": "The operation could not be completed. Try again or contact your administrator.",
  "SERVICE_UNAVAILABLE": "The service is unavailable right now. Try again shortly.",
  "NO_TIER_FOR_AMOUNT": "No tier for this amount",
  "COMMISSION_NOT_BELOW_AMOUNT": "The commission must be less than the transfer amount",
  "INSUFFICIENT_BALANCE": "The balance is not enough for this operation",
  "TIER_LIMIT_TAKEN": "Another tier has the same upper limit",
  "TIER_UNLIMITED_EXISTS": "Another tier already has no upper limit",
  "IN_USE": "It cannot be deleted because it is in use. You can disable it instead.",
  "HOLDER_INACTIVE": "The box or bank account is inactive",
  "BRANCH_NOT_ALLOWED": "Not available in this branch",
  "CODE_TAKEN": "This code is already in use",
  "IBAN_TAKEN": "This IBAN belongs to another account",
  "ACCOUNT_NUMBER_TAKEN": "This account number belongs to another account",
  "INVALID_STATE": "This action is not possible in the transfer's current state",
  "CAPTURE_INCOMPLETE": "The receiver's data or signature is incomplete",
  "NOTHING_TO_CHANGE": "There are no changes to save",
  "TABLET_NOT_CONFIGURED": "The tablet service is not connected to this system",
  "TABLET_UNAVAILABLE": "The tablet service could not be reached; try again",
  "TABLET_NOT_AVAILABLE": "The tablet is not available in this branch",
  "TABLET_BUSY": "The tablet is busy",
  "FILE_INVALID": "The file is not valid",
  "CUSTOMERS_UNAVAILABLE": "Could not link to the Customers platform, try again",
  "CUSTOMER_NOT_PRESENT": "This transfer was saved as \"Customer not present\": it is not sent to the tablet and takes no customer data",
  "network": "Could not reach the server. Check your connection and try again.",
  "timeout": "We could not confirm this finished. Check the current state before trying again.",
  "referenceId": "Reference: {{requestId}}",
  "PHONE_REQUIRED": "The phone number is required",
  "PHONE_INVALID": "The phone number is not valid",
  "PHONE_NOT_MOBILE": "Landline numbers are not allowed. Enter a mobile number",
  "PHONE_COUNTRY_NOT_ALLOWED": "Numbers from this country are not accepted",
  "PHONE_VERIFICATION_REQUIRED": "Verify the phone number before saving",
  "PHONE_VERIFICATION_INVALID": "The code has expired. Request a new code",
  "OTP_INVALID": "The code is incorrect",
  "OTP_EXPIRED": "The code has expired. Request a new code",
  "OTP_ATTEMPTS_EXCEEDED": "Too many wrong attempts. Request a new code",
  "OTP_RESEND_TOO_SOON": "The code cannot be resent yet",
  "OTP_SEND_LIMIT": "Too many codes were sent to this number",
  "OTP_SEND_FAILED": "The verification code could not be sent by WhatsApp. Nothing was saved. Try again, or an administrator can turn verification off in the settings",
  "OTP_ALREADY_VERIFIED": "The phone number has been verified",
  "OTP_ALREADY_CONSUMED": "The code has expired. Request a new code",
  "OTP_BINDING_MISMATCH": "The code has expired. Request a new code",
  "OTP_NOT_VERIFIED": "Verify the phone number before saving",
  "OTP_CONSUME_WINDOW_PASSED": "The code has expired. Request a new code",
  "IDEMPOTENCY_CONFLICT": "This request number was already used for another operation",
  "PHONE_VERIFICATION_RECEIPT_EXPIRED": "The phone verification expired. Verify again",
  "CUSTOMERS_CALL_IN_FLIGHT": "The customer's details are being sent to the Customers system; try again in a moment"
}
